require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-04-bye-bye-u-3.json") })
        }
      }, "path---articles-2008-04-bye-bye-u-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-04-bye-bye-u-3!./.cache/json/articles-2008-04-bye-bye-u-3.json
// module id = 380
// module chunks = 231608221292675